import classNames from "classnames";
import { BookingDetailItem } from "PFApp/booking/components/booking_detail_item";
import { BookingPill } from "PFApp/components/pills/booking_pill";
import { AccessLevel, BookingCategory } from "PFTypes";
import { useTranslation } from "react-i18next";

import css from "../../detail_view.module.scss";

type BookingDetailCategoryProps = {
  category: BookingCategory;
};

export const BookingDetailCategory = ({ category }: BookingDetailCategoryProps) => {
  const { t } = useTranslation("translation");
  const isCategoryHidden = !category || category.bookings_permissions === AccessLevel.Hidden;
  return (
    <div className={classNames(css.alignCenter, css.bookingCategory)}>
      <BookingDetailItem label={t("category")} value={category.display_as} />
      <BookingPill
        category={!isCategoryHidden ? category : undefined}
        className={css.bookingCategoryPill}
        center
      />
    </div>
  );
};
